import { motion } from "framer-motion";

const types = [
  "Multifamily",
  "Mixed-Use",
  "Retail",
  "Industrial",
  "Land",
  "Subdivisions",
  "Build-to-Rent",
  "Commercial Development",
];

export default function PropertyTypes() {
  return (
    <section className="relative py-20 lg:py-24 border-t border-[#D4AF37]/10 bg-[#080808]" data-testid="property-types-section">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 text-center">
        <motion.p
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="text-[11px] tracking-[0.45em] uppercase text-[#D4AF37] mb-10"
          data-testid="property-types-overline"
        >
          Property Types We Finance
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, delay: 0.1 }}
          className="flex flex-wrap justify-center gap-x-8 gap-y-4"
          data-testid="property-types-list"
        >
          {types.map((t) => (
            <span key={t} className="flex items-center gap-8 font-display text-xl sm:text-2xl font-light tracking-wide text-[#F5F5F5]">
              {t}
              <span className="w-1.5 h-1.5 bg-[#D4AF37] rotate-45 last:hidden" aria-hidden="true" />
            </span>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
